/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbPutRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbConfigReferenceTypeByIdUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ReferenceType, ActionApi } from './ActionApi.types.tsx';

export type ReferenceTypeProperties = {
	name?: string;
	displayName?: string;
	description?: string;
	color?: string;
};

export type RequestBodyType = {
	referenceTypeId: string;
	updatedProperties: ReferenceTypeProperties;
};

export const setReferenceType =
	(updatedReferenceType: ReferenceType): ActionApi =>
	async ({ setState, getState }) => {
		const state = getState();
		const updatedData = state.referenceTypes.data?.map((referenceType) =>
			referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType,
		);

		setState({
			...state,
			referenceTypes: { ...state.referenceTypes, data: updatedData },
		});
	};

export const updateReferenceType =
	({ referenceTypeId, updatedProperties }: RequestBodyType): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			referenceTypes: { ...state.referenceTypes, updateLoading: true },
		});

		try {
			const response = await performCmdbPutRequest(
				getCmdbConfigReferenceTypeByIdUrl(workspaceId, referenceTypeId),
				{
					body: JSON.stringify({
						...updatedProperties,
						color:
							updatedProperties.color !== undefined
								? updatedProperties.color.replace('#', '')
								: undefined,
					}),
				},
			);
			const updatedState = getState();
			let merged: ReferenceType = response;
			if (fg('cdm_display_name')) {
				const displayNameMerged =
					response.displayName !== undefined && response.displayName !== null
						? response.displayName
						: updatedProperties.displayName;
				merged = {
					...response,
					...(displayNameMerged !== undefined ? { displayName: displayNameMerged } : {}),
				};
			}
			const updatedData = updatedState.referenceTypes.data?.map((referenceType) =>
				referenceType.id === response.id ? merged : referenceType,
			);

			setState({
				...updatedState,
				referenceTypes: {
					...updatedState.referenceTypes,
					updateLoading: false,
					data: updatedData || undefined,
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'updateReferenceType succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			const updatedState = getState();

			setState({
				...updatedState,
				referenceTypes: {
					...updatedState.referenceTypes,
					updateLoading: false,
					updateError: error,
				},
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'updateReferenceType',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
